export default {
  title: "Authentifizierung",
  login: {
    title: "Anmelden",
    description: "Melden Sie sich bei Ihrem Konto an",
    form: {
      email: "E-Mail",
      password: "Passwort",
      rememberMe: "Angemeldet bleiben",
      submit: "Einloggen",
      forgotPassword: "Passwort vergessen?"
    },
    errors: {
      invalidCredentials: "Falsche E-Mail oder Passwort",
      userNotFound: "Kein Konto mit dieser E-Mail gefunden",
      tooManyAttempts: "Zu viele Versuche, bitte versuchen Sie es später erneut"
    }
  },
  logout: "Abmelden",
  register: {
    title: "Registrieren",
    description: "Erstellen Sie Ihr Konto",
    form: {
      firstName: "Vorname",
      lastName: "Nachname",
      email: "E-Mail",
      password: "Passwort",
      confirmPassword: "Passwort bestätigen",
      terms: "Ich akzeptiere die Nutzungsbedingungen",
      submit: "Registrieren"
    },
    errors: {
      emailExists: "Ein Konto mit dieser E-Mail existiert bereits",
      passwordTooWeak: "Das Passwort ist zu schwach",
      passwordsDontMatch: "Die Passwörter stimmen nicht überein",
      termsNotAccepted: "Sie müssen die Nutzungsbedingungen akzeptieren"
    }
  },
  forgotPassword: {
    title: "Passwort vergessen",
    description: "Setzen Sie Ihr Passwort zurück",
    form: {
      email: "E-Mail",
      submit: "Link zum Zurücksetzen senden"
    },
    success: "Eine E-Mail zum Zurücksetzen wurde gesendet",
    errors: {
      userNotFound: "Kein Konto mit dieser E-Mail gefunden",
      tooManyAttempts: "Zu viele Versuche, bitte versuchen Sie es später erneut"
    }
  },
  resetPassword: {
    title: "Passwort zurücksetzen",
    description: "Wählen Sie ein neues Passwort",
    form: {
      password: "Neues Passwort",
      confirmPassword: "Passwort bestätigen",
      submit: "Passwort zurücksetzen"
    },
    success: "Ihr Passwort wurde zurückgesetzt",
    errors: {
      invalidToken: "Der Link zum Zurücksetzen ist ungültig oder abgelaufen",
      passwordTooWeak: "Das Passwort ist zu schwach",
      passwordsDontMatch: "Die Passwörter stimmen nicht überein"
    }
  },
  email: "E-Mail",
  password: "Passwort",
  confirmPassword: "Passwort bestätigen",
  rememberMe: "Angemeldet bleiben",
  loginButton: "Anmelden",
  registerButton: "Registrieren",
  loginWithGoogle: "Mit Google anmelden",
  loginWithFacebook: "Mit Facebook anmelden",
  registerWithGoogle: "Mit Google registrieren",
  registerWithFacebook: "Mit Facebook registrieren",
  or: "oder",
  alreadyHaveAccount: "Haben Sie bereits ein Konto?",
  dontHaveAccount: "Haben Sie noch kein Konto?",
  loginHere: "Hier anmelden",
  registerHere: "Hier registrieren",
  sendResetEmail: "Reset-E-Mail senden",
  backToLogin: "Zurück zur Anmeldung",
  checkEmail: "Überprüfen Sie Ihre E-Mail",
  resetEmailSent: "Passwort-Reset-E-Mail gesendet",
  invalidCredentials: "Ungültige Anmeldedaten",
  emailRequired: "E-Mail ist erforderlich",
  passwordRequired: "Passwort ist erforderlich",
  emailInvalid: "Ungültige E-Mail-Adresse",
  passwordTooShort: "Passwort muss mindestens 6 Zeichen lang sein",
  passwordsMismatch: "Passwörter stimmen nicht überein",
  loginSuccess: "Anmeldung erfolgreich",
  registrationSuccess: "Registrierung erfolgreich",
  logoutSuccess: "Abmeldung erfolgreich",
  error: "Authentifizierungsfehler",
  loginError: "Anmeldefehler",
  registrationError: "Registrierungsfehler",
  resetPasswordError: "Passwort-Reset-Fehler",
  socialLoginError: "Social-Login-Fehler",
  weakPassword: "Passwort ist zu schwach",
  emailAlreadyExists: "E-Mail existiert bereits",
  userNotFound: "Benutzer nicht gefunden",
  wrongPassword: "Falsches Passwort",
  tooManyRequests: "Zu viele Anfragen, bitte versuchen Sie es später erneut",
  networkError: "Netzwerkverbindungsfehler. Bitte überprüfe deine Internetverbindung.",
  emailVerificationRequired: "E-Mail-Verifizierung erforderlich",
  emailVerificationSent: "Verifizierungs-E-Mail gesendet",
  verifyEmail: {
    title: "E-Mail überprüfen",
    description: "Überprüfen Sie Ihre E-Mail-Adresse",
    success: "Ihre E-Mail wurde verifiziert",
    resend: "Bestätigungs-E-Mail erneut senden",
    errors: {
      invalidToken: "Der Bestätigungslink ist ungültig oder abgelaufen",
      alreadyVerified: "Diese E-Mail ist bereits verifiziert"
    }
  },
  resendVerification: "Verifizierung erneut senden",
  emailVerified: "E-Mail erfolgreich verifiziert",
  verificationError: "Verifizierungsfehler",
  continueWithEmail: "Mit E-Mail fortfahren",
  continueWithPassword: "Mit Passwort fortfahren",
  terms: "Nutzungsbedingungen",
  privacy: "Datenschutzrichtlinie",
  agreeToTerms: "Ich stimme den Nutzungsbedingungen und der Datenschutzrichtlinie zu",
  termsRequired: "Sie müssen den Nutzungsbedingungen zustimmen",
  firstName: "Vorname",
  lastName: "Nachname",
  fullName: "Vollständiger Name",
  loading: "Wird geladen...",
  pleaseWait: "Bitte warten...",
  welcome: "Willkommen",
  welcomeBack: "Willkommen zurück",
  loginWithApple: "Mit Apple anmelden",
  signupWithGoogle: "Mit Google registrieren",
  signupWithFacebook: "Mit Facebook registrieren",
  signupWithApple: "Mit Apple registrieren",
  loggingIn: "Anmeldung läuft...",
  continueWith: "Oder fortfahren mit",
  protectedBy: "Geschützt durch",
  termsNotice: "Indem du fortfährst, akzeptierst du unsere",
  termsOfService: "Nutzungsbedingungen",
  and: "und unsere",
  privacyPolicy: "Datenschutzrichtlinie",
  verifyPhone: "Telefon verifizieren",
  verifyPhoneMessage: "Geben Sie Ihre Telefonnummer ein, um einen Verifizierungscode per SMS zu erhalten",
  phoneNumber: "Telefonnummer",
  phoneNumberFormat: "Ohne die erste Null für Frankreich, z.B.: 612345678",
  skipStep: "Diesen Schritt vorerst überspringen",
  verifySms: "SMS-Code verifizieren",
  verifySmsMessage: "Wir haben einen 6-stelligen Code an die Nummer gesendet",
  resendCodeIn: "Code erneut senden in",
  resendCode: "Code erneut senden",
  verifyEmailMessage: "Wir haben einen 6-stelligen Code gesendet an",
  verifyingEmail: "E-Mail wird verifiziert...",
  tryAgain: "Erneut versuchen",
  redirecting: "Weiterleitung...",
  noCodeReceived: "Keinen Code erhalten?",
  accessLevels: {
    view: "Nur anzeigen",
    edit: "Bearbeiten",
    manage: "Vollständige Verwaltung"
  },
  accessInfo: {
    connectedAs: "Angemeldet als"
  },
  accessRestriction: {
    title: "Zugriff eingeschränkt",
    insufficientLevel: "Unzureichende Zugriffsebene",
    login: "Anmelden"
  },
  currentLevel: "Aktuelle Ebene",
  requiredLevel: "Erforderliche Ebene",
  errors: {
    default: "Ein Fehler ist aufgetreten",
    suspiciousActivity: "Verdächtige Aktivität erkannt. Bitte versuchen Sie es erneut.",
    recaptchaFailed: "Sicherheitsverifizierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    recaptchaUnavailable: "Sicherheitsdienst ist vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.",
    recaptchaTimeout: "Sicherheitsverifizierung dauerte zu lange. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    accountExistsWithDifferentCredential: "Ein Konto existiert bereits mit anderen Anmeldedaten",
    popupClosed: "Anmeldefenster wurde geschlossen",
    disallowedUserAgent: "Nicht erlaubter Benutzeragent",
    socialLoginFailed: "Social Login fehlgeschlagen",
    invalidPhone: "Ungültige Telefonnummer",
    genericError: "Ein Fehler ist aufgetreten",
    invalidCode: "Ungültiger Code, bitte geben Sie die 6 Ziffern ein.",
    loginFailed: "Anmeldung fehlgeschlagen",
    googleLoginFailed: "Google-Anmeldung fehlgeschlagen",
    facebookLoginFailed: "Facebook-Anmeldung fehlgeschlagen",
    emailAlreadyInUse: "Diese E-Mail wird bereits verwendet",
    invalidEmail: "Ungültige E-Mail",
    emailNotFound: "E-Mail nicht gefunden. Bitte wiederholen Sie den Registrierungsprozess.",
    verificationFailed: "Verifizierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    invalidLink: "Ungültiger Verifizierungslink.",
    pendingInvitation: "Fehler beim Überprüfen ausstehender Einladungen",
    accept: "Fehler beim Annehmen der Einladung",
    decline: "Fehler beim Ablehnen der Einladung",
    loadInvitation: "Fehler beim Laden der Einladung",
    accountExists: "Es existiert bereits ein Konto mit dieser E-Mail-Adresse, jedoch mit einer anderen Anmeldemethode.",
    operationNotAllowed: "Diese Anmeldemethode ist nicht aktiviert. Bitte kontaktiere den Support.",
    emailInUse: "Diese E-Mail wird bereits verwendet",
    networkError: "Netzwerkfehler",
    popupCancelled: "Vorgang abgebrochen",
    tooManyRequests: "Zu viele Versuche, bitte versuchen Sie es später erneut",
    weakPassword: "Das Passwort ist zu schwach",
    wrongPassword: "Falsches Passwort",
    userNotFound: "Benutzer nicht gefunden"
  },
  webViewWarning: "Um dich mit Google anzumelden, öffne diese Seite bitte in einem Standardbrowser wie Safari, Chrome oder Firefox.",
  signIn: "Anmelden",
  createAccount: {
    submit: "Konto erstellen",
    title: "Konto erstellen",
    description: "Erstellen Sie ein Konto, um Ihre Hochzeit zu verwalten",
    benefits: "Vorteile der Kontoerstellung"
  },
  signInWithGoogle: "Mit Google anmelden",
  continueAsGuest: "Als Gast fortfahren",
  oauth: {
    google: "Weiter mit Google",
    facebook: "Weiter mit Facebook",
    apple: "Weiter mit Apple"
  },
  messages: {
    loggedIn: "Erfolgreich angemeldet",
    loggedOut: "Erfolgreich abgemeldet",
    registered: "Konto erfolgreich erstellt",
    emailVerified: "E-Mail erfolgreich verifiziert",
    passwordReset: "Passwort erfolgreich zurückgesetzt"
  },
  facebook: {
    accountExists: {
      description: "Es existiert bereits ein Konto mit dieser E-Mail, das mit einer anderen Anmeldemethode verknüpft ist.",
      step1: "Melden Sie sich mit Ihrer üblichen Methode an",
      step2: "Verknüpfen Sie Ihr Facebook-Konto in den Einstellungen",
      title: "Vorhandenes Konto"
    },
    general: {
      privacy: "Datenschutz",
      privacyText: "Wir werden niemals etwas ohne Ihre Erlaubnis auf Ihrer Pinnwand veröffentlichen.",
      tip1: "Stellen Sie sicher, dass Pop-ups zugelassen sind",
      tip2: "Überprüfen Sie, ob Sie bei Facebook angemeldet sind",
      tip3: "Erlauben Sie den Zugriff auf Ihre E-Mail",
      tip4: "Wenn der Fehler weiterhin besteht, versuchen Sie es mit einem anderen Browser",
      tip5: "Oder verwenden Sie E-Mail und Passwort",
      title: "Mit Facebook anmelden"
    },
    popupBlocked: {
      description: "Der Browser hat das Facebook-Anmeldefenster blockiert.",
      note: "Hinweis",
      noteText: "Wenn das Problem weiterhin besteht, versuchen Sie, Ihren Werbeblocker vorübergehend zu deaktivieren.",
      step1: "Suchen Sie nach dem Blocker-Symbol in der Adressleiste",
      step2: "Klicken Sie darauf und lassen Sie Pop-ups für diese Website zu",
      step3: "Versuchen Sie erneut, sich anzumelden",
      title: "Pop-up blockiert"
    },
    unauthorizedDomain: {
      title: "Nicht autorisierte Domain",
      description: "Diese Domain ist nicht für die Facebook-Authentifizierung autorisiert.",
      note: "Hinweis",
      noteText: "Bitte kontaktieren Sie den Administrator."
    },
    understood: "Verstanden"
  }
};
